// extracted by mini-css-extract-plugin
export var activeDot = "_58-c";
export var buttonContainer = "_58-9";
export var channelButton = "_58-a";
export var clickable = "_58-d";
export var content = "_58-0";
export var contentFull = "_58-2";
export var contentThird = "_58-1";
export var contentWrapper = "_58-7";
export var description = "_58-5";
export var heightShort = "_58-f";
export var image = "_58-3";
export var imageContainer = "_58-4";
export var selectButton = "_58-e";
export var spinnerContainer = "_58-b";
export var titleContent = "_58-8";
export var titleWrapper = "_58-6";